import Widget from 'models/dashboard/widget'

Widget.AgentTopSourcesWidget = Widget.extend({
  agentIds: function () {
    return this.get('agent_ids');
  }
});

export default Widget.AgentTopSourcesWidget;

